namespace Serenity {

    @Serenity.Decorators.registerInterface()
    export class IDecimalValue {
    }

    export interface IDecimalValue {
        get_value(): any;
        set_value(value: any): void;
    }
}